function isTauri(): boolean {
  return typeof window !== "undefined" && "__TAURI_INTERNALS__" in window;
}

export type EventModelOccurrence = { start: number; end: number };

export async function getEventModelTimes(
  configName: string,
  sessionType: string,
  modelName: string,
): Promise<EventModelOccurrence[]> {
  if (isTauri()) {
    const { invoke } = await import("@tauri-apps/api/core");
    const pairs = await invoke<Array<[number, number]>>("get_event_model_times", {
      configName,
      sessionType,
      modelName,
    });
    return pairs.map(([start, end]) => ({ start, end }));
  }
  const url = `/api/get_event_model_times?config_name=${encodeURIComponent(configName)}&session_type=${encodeURIComponent(sessionType)}&model_name=${encodeURIComponent(modelName)}`;
  const response = await fetch(url);
  if (!response.ok) throw new Error(`getEventModelTimes failed: ${response.status}`);
  const pairs = (await response.json()) as Array<[number, number]>;
  return pairs.map(([start, end]) => ({ start, end }));
}
